import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 368px;
  height: 164px;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0px 8px 22px -6px rgba(24, 39, 75, 0.04),
    0px 14px 64px -4px rgba(24, 39, 75, 0.04);

  .row-first-child {
    padding-bottom: 8px;
  }

  > .ant-row > .ant-tag {
    margin: 0;
  }

  .typography {
    color: ${"#8c8c8c"};
    line-height: 24px;
  }

  .ant-typography-ellipsis {
    max-width: 230px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    color: ${"#434343"};
    padding-right: 8px;
  }

  && svg {
    color: ${"#8c8c8c"};
  }
`;

export const StyledWrapperCard = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  -webkit-box-pack: justify;
  align-items: stretch;
  flex-direction: column;
`;

export const StyledWrapperExtra = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  -webkit-box-pack: justify;
  align-items: flex-end;
  flex-direction: column;
  justify-content: flex-end;
`;
